import { createContext, useState } from 'react';
import { MAX_COMPARE } from '../utils/compare.utils';

// Planos marcados para comparar (máximo de MAX_COMPARE).
export const CompareContext = createContext({
  compareList: [],
  isInCompare: () => false,
  toggleCompare: () => {},
  clearCompare: () => {},
});

const samePlan = (a, b) =>
  a.insuranceCompany === b.insuranceCompany && a.insuranceId === b.insuranceId;

export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState([]);

  const isInCompare = (plan) => compareList.some((p) => samePlan(p, plan));

  const toggleCompare = (plan) =>
    setCompareList((list) => {
      if (list.some((p) => samePlan(p, plan))) {
        return list.filter((p) => !samePlan(p, plan));
      }
      return list.length >= MAX_COMPARE ? list : [...list, plan];
    });

  const clearCompare = () => setCompareList([]);

  return (
    <CompareContext.Provider value={{ compareList, isInCompare, toggleCompare, clearCompare }}>
      {children}
    </CompareContext.Provider>
  );
};
